import { render, staticRenderFns } from "./ConfigWrap.vue?vue&type=template&id=eb714a42&scoped=true"
import script from "./ConfigWrap.vue?vue&type=script&lang=js"
export * from "./ConfigWrap.vue?vue&type=script&lang=js"
import style0 from "./ConfigWrap.vue?vue&type=style&index=0&id=eb714a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb714a42",
  null
  
)

export default component.exports